<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Maszyny drukujące</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Maszyny drukujące</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Maszyny drukujące</h5>
            <span class="ibox-toggle" @click="isMainOpen = !isMainOpen">
              <i :class="chevronMainClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddPlate" to="/plates/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @expand-row="editPlate"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #expand>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Edycja maszyny drukującej</h5>
                            <span
                              class="ibox-toggle"
                              @click="isEditOpen = !isEditOpen"
                            >
                              <i :class="chevronEditClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isEditOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="plateObj.name"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Wymiar x
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="plateObj.size_x"
                                      name="size_x"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Wymiar x"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.size_x"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.size_x[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Wymiar y
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="plateObj.size_y"
                                      name="size_y"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Wymiar y"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.size_y"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.size_y[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Cena
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="plateObj.price"
                                      name="price"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Wymiar y"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.price"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.price[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Max format zadruku
                                  </label>
                                  <div class="col-sm-10 flex-inputs">
                                    <div>
                                      <input
                                        v-model="plateObj.max_print_x"
                                        type="text"
                                        class="form-control inputClass"
                                        placeholder="x"
                                        required="required"
                                      />
                                      <div
                                        v-if="
                                          errorsAdminData?.data?.max_print_x
                                        "
                                        class="has-error"
                                      >
                                        <span class="help-block">
                                          {{
                                            errorsAdminData.data.max_print_x[0]
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                    <div>
                                      <input
                                        v-model="plateObj.max_print_y"
                                        type="text"
                                        class="form-control inputClass"
                                        placeholder="y"
                                        required="required"
                                      />
                                      <div
                                        v-if="
                                          errorsAdminData?.data?.max_print_y
                                        "
                                        class="has-error"
                                      >
                                        <span class="help-block">
                                          {{
                                            errorsAdminData.data.max_print_y[0]
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Min format zadruku
                                  </label>
                                  <div class="col-sm-10 flex-inputs">
                                    <div>
                                      <input
                                        v-model="plateObj.min_print_x"
                                        type="text"
                                        class="form-control inputClass"
                                        placeholder="x"
                                        required="required"
                                      />
                                      <div
                                        v-if="
                                          errorsAdminData?.data?.min_print_x
                                        "
                                        class="has-error"
                                      >
                                        <span class="help-block">
                                          {{
                                            errorsAdminData.data.min_print_x[0]
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                    <div>
                                      <input
                                        v-model="plateObj.min_print_y"
                                        type="text"
                                        class="form-control inputClass"
                                        placeholder="y"
                                        required="required"
                                      />
                                      <div
                                        v-if="
                                          errorsAdminData?.data?.min_print_y
                                        "
                                        class="has-error"
                                      >
                                        <span class="help-block">
                                          {{
                                            errorsAdminData.data.min_print_y[0]
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Format matrycy
                                  </label>
                                  <div class="col-sm-10 flex-inputs">
                                    <div>
                                      <input
                                        v-model="plateObj.matrix_x"
                                        type="text"
                                        class="form-control inputClass"
                                        placeholder="x"
                                        required="required"
                                      />
                                      <div
                                        v-if="errorsAdminData?.data?.matrix_x"
                                        class="has-error"
                                      >
                                        <span class="help-block">
                                          {{ errorsAdminData.data.matrix_x[0] }}
                                        </span>
                                      </div>
                                    </div>
                                    <div>
                                      <input
                                        v-model="plateObj.matrix_y"
                                        type="text"
                                        class="form-control inputClass"
                                        placeholder="y"
                                        required="required"
                                      />
                                      <div
                                        v-if="errorsAdminData?.data?.matrix_y"
                                        class="has-error"
                                      >
                                        <span class="help-block">
                                          {{ errorsAdminData.data.matrix_y[0] }}
                                        </span>
                                      </div>
                                    </div>
                                    <div>
                                      <input
                                        v-model="plateObj.matrix_cost_per_m2"
                                        type="text"
                                        class="form-control inputClass"
                                        placeholder="Koszt [m2]"
                                        required="required"
                                      />
                                      <div
                                        v-if="
                                          errorsAdminData?.data
                                            ?.matrix_cost_per_m2
                                        "
                                        class="has-error"
                                      >
                                        <span class="help-block">
                                          {{
                                            errorsAdminData.data
                                              .matrix_cost_per_m2[0]
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label
                                    for="username"
                                    class="control-label col-sm-2"
                                  >
                                    Wydajność [arkusz/h]
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="plateObj.sheets_per_hour"
                                      name="price"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Wydajność [arkusz/h]"
                                      required="required"
                                    />
                                    <div
                                      v-if="
                                        errorsAdminData?.data?.sheets_per_hour
                                      "
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data
                                            .sheets_per_hour[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  v-for="(cost, key) in operational_costs || []"
                                  :key="key"
                                  class="form-group"
                                >
                                  <label class="control-label col-sm-2">
                                    <div>Koszty eksploatacyjne stałe</div>
                                  </label>
                                  <div class="col-sm-10 flex-inputs">
                                    <div class="mr-20">
                                      <div class="multiselect-with-buttons">
                                        <Multiselect
                                          v-model="operational_costs[key].type"
                                          mode="single"
                                          placeholder="Typ"
                                          track-by="name"
                                          label="name"
                                          :close-on-select="true"
                                          :searchable="true"
                                          :resolve-on-blur="false"
                                          :options="units"
                                          :object="true"
                                          :filter="customFilter"
                                          class="flexible-multiselect"
                                          @open="() => {}"
                                          @select="(option) => {}"
                                        >
                                          <template #option="{ option }">
                                            <div class="option-with-delete">
                                              <button
                                                v-if="canDeleteUnit"
                                                type="button"
                                                class="btn btn-sm btn-danger delete-btn"
                                                @click.stop="
                                                  confirmDeleteUnit(option)
                                                "
                                                title="Usuń jednostkę"
                                              >
                                                ×
                                              </button>
                                              <span class="option-text">
                                                {{ option.name }} ({{
                                                  option.symbol
                                                }})
                                              </span>
                                            </div>
                                          </template>
                                        </Multiselect>
                                        <button
                                          v-if="canAddUnit"
                                          type="button"
                                          class="btn btn-sm btn-success add-unit-btn"
                                          @click="showUnitModal = true"
                                          title="Dodaj nową jednostkę"
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                    <div class="mr-20">
                                      <input
                                        v-model="operational_costs[key].name"
                                        name="name"
                                        type="text"
                                        class="form-control inputClass"
                                        placeholder="Nazwa"
                                        required="required"
                                      />
                                    </div>
                                    <div>
                                      <input
                                        v-model="operational_costs[key].amount"
                                        name="format_y"
                                        type="text"
                                        class="form-control inputClass"
                                        placeholder="Wartość"
                                        required="required"
                                      />
                                    </div>
                                    <div>
                                      <button
                                        @click="removeCost(key)"
                                        class="btn btn-default"
                                      >
                                        Usuń
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    <div>
                                      <button
                                        @click="addCost"
                                        class="btn btn-default"
                                      >
                                        Dodaj koszt stały
                                      </button>
                                    </div>
                                  </label>
                                </div>

                                <div class="hr-line-dashed"></div>

                                <div class="form-group">
                                  <div class="col-sm-4 col-sm-offset-2">
                                    <button
                                      class="btn btn-white"
                                      @click="cancel"
                                    >
                                      Anuluj
                                    </button>
                                    <button
                                      v-if="canChangePlate"
                                      @click="saveEdit"
                                      class="btn btn-primary"
                                    >
                                      Zapisz
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #item-actions="item">
                    <button
                      v-if="canDeletePlate"
                      @click.stop="
                        showModal = item.pk;
                        deleteName = item.name;
                      "
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deletePlates(showModal)"
    @callbackClose="showModal = false"
  />

  <!-- Modal for creating new unit -->
  <div
    v-if="showUnitModal"
    class="modal fade show"
    style="display: block; background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Dodaj nową jednostkę</h4>
          <button type="button" class="close" @click="showUnitModal = false">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Nazwa jednostki</label>
            <input
              v-model="newUnit.name"
              type="text"
              class="form-control"
              placeholder="np. Kilowatogodzina"
            />
          </div>
          <div class="form-group">
            <label>Symbol</label>
            <input
              v-model="newUnit.symbol"
              type="text"
              class="form-control"
              placeholder="np. kWh"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="showUnitModal = false"
          >
            Anuluj
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="createUnit"
            :disabled="!newUnit.name || !newUnit.symbol"
          >
            Dodaj jednostkę
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal potwierdzenia usuwania jednostki -->
  <div
    v-if="showDeleteConfirmModal"
    class="modal fade show"
    style="display: block; background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Potwierdź usunięcie</h4>
          <button
            type="button"
            class="close"
            @click="showDeleteConfirmModal = false"
          >
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            Czy na pewno chcesz usunąć jednostkę
            <strong>{{ selectedUnitForDelete?.name }}</strong>
            ({{ selectedUnitForDelete?.symbol }})?
          </p>
          <p class="text-danger">
            <small>Ta operacja nie może być cofnięta.</small>
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="showDeleteConfirmModal = false"
          >
            Anuluj
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="executeDeleteUnit"
          >
            Usuń
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import {
  platePermissionsConst,
  unitPermissionsConst,
} from "../../constants/productionConstants";
import Modal from "../caffeprint/Modal.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

export default {
  name: "PlatesList",
  mixins: [],
  components: {
    Modal,
    Multiselect,
  },
  props: {},

  setup() {
    const units = ref([]);
    const showUnitModal = ref(false);
    const newUnit = ref({
      name: "",
      symbol: "",
    });
    const selectedUnitForDelete = ref(null);
    const showDeleteConfirmModal = ref(false);
    const errorsAdminData = ref();
    const showErrors = ref(false);
    const store = useStore();
    // Units are shared by machines and printing machines, with permissions of
    // their own.
    const canAddUnit = computed(() => hasPermission(unitPermissionsConst.add));
    const canDeleteUnit = computed(() =>
      hasPermission(unitPermissionsConst.delete)
    );
    const canAddPlate = computed(() =>
      hasPermission(platePermissionsConst.add)
    );
    const canChangePlate = computed(() =>
      hasPermission(platePermissionsConst.update)
    );
    const canDeletePlate = computed(() =>
      hasPermission(platePermissionsConst.delete)
    );
    const deletePlatesData = computed(() => store.getters.getDeletePlatesData);
    const plateData = computed(() => store.getters.getPlateData);
    const updatePlatesData = computed(() => store.getters.getUpdatePlatesData);
    const platesData = computed(() => store.getters.getPlatesData);
    const createPlatesData = computed(() => store.getters.getCreatePlatesData);
    const unitsData = computed(() => store.getters.getUnitsData);
    const createUnitData = computed(() => store.getters.getCreateUnitData);
    const deleteUnitData = computed(() => store.getters.getDeleteUnitData);
    const plateObj = ref({
      name: "",
      size_x: "",
      size_y: "",
      price: "",
    });
    let headers = [
      { text: "Nr", value: "pk" },
      { text: "Nazwa", value: "name", sortable: true, search: true },
      { text: "Wymiar x", value: "size_x", sortable: true, search: true },
      { text: "Wymiar x", value: "size_y", sortable: true, search: true },
      { text: "Cena", value: "price", sortable: true, search: true },
      {
        text: "Data dodania",
        value: "date_added",
        sortable: true,
        search: true,
      },
      {
        text: "Data modyfikacji",
        value: "date_modified",
        sortable: true,
        search: true,
      },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: false,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: false,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const platePK = ref();
    const rowsPerPage = ref();
    const defRowsPerPage = ref(25);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
    });

    const isMainOpen = ref(true);
    const isEditOpen = ref(true);

    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronEditClass = computed(() =>
      isEditOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const operational_costs = ref([
      {
        name: "",
        type: "",
        amount: 0,
      },
    ]);

    const getPlates = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getPlates", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const deletePlates = (pk) => {
      showModal.value = false;
      if (!canDeletePlate.value) {
        return;
      }
      store.dispatch("deletePlates", {
        pk: pk,
      });
    };
    const saveEdit = () => {
      if (!canChangePlate.value) {
        return;
      }
      // Synchronizuj operational_costs przed zapisem
      plateObj.value.operational_costs = [...operational_costs.value];

      // Mapuj operational_costs żeby przekonwertować type na unit dla API
      const mappedOperationalCosts = plateObj.value.operational_costs.map(
        (cost) => ({
          name: cost.name,
          amount: cost.amount,
          unit: cost.type && cost.type.pk ? cost.type.pk : null,
        })
      );

      plateObj.value.operational_costs = mappedOperationalCosts;
      store.dispatch("updatePlates", plateObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editPlate = (globalIndex) => {
      cancel();
      const localIndex =
        globalIndex - (serverOptions.value.page - 1) * defRowsPerPage.value;
      platePK.value = items.value[localIndex].pk;
      store.dispatch("getPlate", { pk: items.value[localIndex].pk });
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getPlates();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getPlates();
    };

    const updateSort = () => {
      search.value = true;
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    const customFilter = (option, label, search) => {
      if (!search) return true;
      const searchLower = search.toLowerCase();
      return (
        option.name.toLowerCase().includes(searchLower) ||
        option.symbol.toLowerCase().includes(searchLower)
      );
    };

    const addCost = () => {
      operational_costs.value.push({
        name: "",
        type: "",
        amount: 0,
      });
    };

    const removeCost = (key) => {
      operational_costs.value.splice(key, 1);
    };

    const fetchUnits = async () => {
      store.dispatch("getUnits");
    };

    const createUnit = async () => {
      if (!canAddUnit.value) {
        return;
      }
      try {
        await store.dispatch("createUnit", newUnit.value);
      } catch (error) {
        console.error("Error creating unit:", error);
      }
    };

    const deleteUnit = async (unitId) => {
      if (!canDeleteUnit.value) {
        return;
      }
      try {
        await store.dispatch("deleteUnit", unitId);
      } catch (error) {
        console.error("Error deleting unit:", error);
      }
    };

    const confirmDeleteUnit = (unit) => {
      if (!canDeleteUnit.value) {
        return;
      }
      selectedUnitForDelete.value = unit;
      showDeleteConfirmModal.value = true;
    };

    const executeDeleteUnit = async () => {
      if (selectedUnitForDelete.value) {
        await deleteUnit(selectedUnitForDelete.value.pk);
        showDeleteConfirmModal.value = false;
        selectedUnitForDelete.value = null;
      }
    };

    const reprocessOperationalCosts = () => {
      if (operational_costs.value && Array.isArray(operational_costs.value)) {
        operational_costs.value = operational_costs.value.map((cost) => {
          let processedType = cost.type;
          if (cost.unit && typeof cost.unit === "object") {
            processedType = {
              pk: cost.unit.pk,
              name: cost.unit.name,
              symbol: cost.unit.symbol,
              value: cost.unit.pk,
            };
          } else if (cost.type && typeof cost.type === "object") {
            processedType = {
              pk: cost.type.pk,
              name: cost.type.name,
              symbol: cost.type.symbol,
              value: cost.type.pk,
            };
          } else if (cost.unit && typeof cost.unit === "number") {
            const unit = units.value.find((u) => u.pk === cost.unit);
            if (unit) {
              processedType = unit;
            }
          } else if (cost.type && typeof cost.type === "number") {
            const unit = units.value.find((u) => u.pk === cost.type);
            if (unit) {
              processedType = unit;
            }
          } else if (cost.name && typeof cost.name === "number") {
            const unit = units.value.find((u) => u.pk === cost.name);
            if (unit) {
              processedType = unit;
            }
          } else if (cost.pk && typeof cost.pk === "number") {
            const unit = units.value.find((u) => u.pk === cost.pk);
            if (unit) {
              processedType = unit;
            }
          } else if (cost.unit_id && typeof cost.unit_id === "number") {
            const unit = units.value.find((u) => u.pk === cost.unit_id);
            if (unit) {
              processedType = unit;
            }
          } else if (cost.type_id && typeof cost.type_id === "number") {
            const unit = units.value.find((u) => u.pk === cost.type_id);
            if (unit) {
              processedType = unit;
            }
          }

          const result = {
            name: cost.name || "",
            type: processedType || "",
            amount: cost.amount || 0,
          };
          return result;
        });
      }
    };

    onMounted(() => {
      if (localStorage.getItem("platesSearchValue") !== null) {
        searchValue.value = localStorage.getItem("platesSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      getPlates();
      fetchUnits();
    });

    watch(
      () => createPlatesData.value,
      function (newValue) {
        if (newValue.status === 201) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Nowa maszyna drukująca została dodana",
          });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "platesSearchValue",
          JSON.stringify(searchValue.value)
        );
        getPlates();
      },
      { deep: true }
    );

    watch(
      () => platesData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => plateData.value,
      function (newValue) {
        plateObj.value = newValue.data;
        // Upewnij się, że operational_costs istnieje i ma poprawną strukturę
        if (
          !plateObj.value.operational_costs ||
          !Array.isArray(plateObj.value.operational_costs)
        ) {
          plateObj.value.operational_costs = [
            {
              name: "",
              type: "",
              amount: 0,
            },
          ];
        } else {
          // Mapuj unit z backendu na type do Multiselect
          plateObj.value.operational_costs =
            plateObj.value.operational_costs.map((cost) => {
              let processedType = "";
              if (cost.unit && typeof cost.unit === "object") {
                processedType = {
                  pk: cost.unit.pk,
                  name: cost.unit.name,
                  symbol: cost.unit.symbol,
                  value: cost.unit.pk,
                };
              } else if (cost.unit && typeof cost.unit === "number") {
                const unit = units.value.find((u) => u.pk === cost.unit);
                if (unit) {
                  processedType = unit;
                }
              }
              return {
                ...cost,
                type: processedType,
              };
            });
        }
        // Synchronizuj z lokalną zmienną operational_costs (jak w PlatesCreate)
        operational_costs.value = [...plateObj.value.operational_costs];
        if (
          !operational_costs.value ||
          !Array.isArray(operational_costs.value)
        ) {
          operational_costs.value = [
            {
              name: "",
              type: "",
              amount: 0,
            },
          ];
        }
        if (units.value.length === 0) {
          reprocessOperationalCosts();
        } else {
          reprocessOperationalCosts();
        }
      }
    );

    watch(
      () => deletePlatesData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Płyta została usunieta",
          });
        }
        getPlates();
      }
    );

    watch(
      () => updatePlatesData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getPlates();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getPlates();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    watch(
      () => unitsData.value,
      function (newValue) {
        units.value = (newValue?.data?.results || []).map((unit) => ({
          ...unit,
          value: unit.pk,
          name: unit.name,
        }));
        reprocessOperationalCosts();
      }
    );

    watch(
      () => createUnitData.value,
      function (newValue) {
        if (newValue.status === 201) {
          newUnit.value = { name: "", symbol: "" };
          showUnitModal.value = false;
          store.dispatch("showToaster", {
            type: "success",
            content: "Nowa jednostka została dodana",
          });
          // Pobierz zaktualizowaną listę jednostek
          fetchUnits();
        } else if (newValue.status) {
          store.dispatch("showToaster", {
            type: "error",
            content: "Błąd podczas dodawania jednostki",
          });
        }
      }
    );

    watch(
      () => deleteUnitData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Jednostka została usunięta",
          });
          fetchUnits(); // Refresh the units list after successful deletion
        }
      }
    );

    return {
      canAddUnit,
      canDeleteUnit,
      canAddPlate,
      canChangePlate,
      canDeletePlate,
      headers,
      items,
      itemsAll,
      loading,
      serverOptions,
      showModal,
      deletePlates,
      deleteName,
      plateObj,
      cancel,
      editPlate,
      saveEdit,
      searchValue,
      search,
      resetFilters,
      updateSort,
      isSearch,
      rowsPerPage,
      selectPage,
      setRowsPerPage,
      operational_costs,
      addCost,
      showErrors,
      errorsAdminData,
      units,
      customFilter,
      showUnitModal,
      newUnit,
      createUnit,
      removeCost,
      selectedUnitForDelete,
      showDeleteConfirmModal,
      confirmDeleteUnit,
      executeDeleteUnit,
      deleteUnitData,
      reprocessOperationalCosts,
      isMainOpen,
      isEditOpen,
      chevronMainClass,
      chevronEditClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.modal {
  z-index: 1050;
}
.modal.show {
  display: block;
}

.multiselect-with-buttons {
  display: flex;
  align-items: center;
  gap: 5px;
}

.add-unit-btn {
  flex-shrink: 0;
  height: 38px;
  width: 38px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
}

/* Dostosowanie Multiselect */
:deep(.multiselect) {
  min-height: 38px;
}

:deep(.multiselect-dropdown) {
  max-height: 200px;
}

:deep(.multiselect-option) {
  padding: 8px 12px;
}

:deep(.multiselect-option:hover) {
  background-color: #f8f9fa;
}

/* Flexible multiselect styling */
.flexible-multiselect {
  min-width: 200px;
  max-width: 400px;
}

:deep(.flexible-multiselect .multiselect-dropdown) {
  min-width: 300px;
  max-width: 500px;
}

:deep(.flexible-multiselect .multiselect-option) {
  white-space: normal;
  overflow: visible;
  word-wrap: break-word;
  min-height: auto;
}

:deep(.flexible-multiselect .multiselect-option.is-selected) {
  color: #333 !important;
}

:deep(.flexible-multiselect .multiselect-option.is-selected:hover) {
  color: #333 !important;
}

:deep(.flexible-multiselect .multiselect-option:hover) {
  background-color: #e9ecef !important;
  color: #495057 !important;
}

.option-with-delete {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 2px 0;
  gap: 8px;
}

.delete-btn {
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.2s;
  padding: 2px 6px;
  font-size: 12px;
  line-height: 1;
  margin-right: 0;
}

.option-text {
  flex: 1;
  overflow: visible;
  white-space: normal;
  word-wrap: break-word;
}

.option-with-delete:hover .delete-btn {
  opacity: 1;
}
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
</style>
